import request from '@/utils/axios'
import { cu } from '../common'

let base = '/backend/interfacemanage'
let spBase = '/backend/sp'

/**
 * 通过用户编码查询用户
 * @param userCode
 * @returns {AxiosPromise}
 */
export const findUserByUserCode = (userCode) => {
  return request({
    url: `${base}${cu}/user/findUserByUserCode?userCode=${userCode}`,
    method: 'get'
  })
}

/**
 * 通过用户登录名查询用户
 * @param loginName
 * @returns {AxiosPromise}
 */
export const findUserByLoginName = (loginName) => {
  return request({
    url: `${base}${cu}/user/findUserByLoginName?loginName=${loginName}`,
    method: 'get'
  })
}

/**
 * 通过手机号查询用户
 * @param phone
 * @returns {AxiosPromise}
 */
export const findUserByPhone = (phone) => {
  return request({
    url: `${base}${cu}/user/findUserByPhone?phone=${phone}`,
    method: 'get'
  })
}

/**
 * 查询用户关联的企业
 * @returns {AxiosPromise}
 */
export const getCurrentUserCorpList = (NotNeedErrorMessage = false) => {
  return request({
    url: `${base}${cu}/user/getCurrentUserCorpList`,
    headers: {
      ...(NotNeedErrorMessage ? { NotNeedErrorMessage: true } : {})
    },
    method: 'get'
  })
}

/**
 * 获取企业用户信息
 * @param corpNo 企业编码，可以为空
 * @param NotNeedErrorMessage 不需要默认的错误提示（by meijiangshun）登录的时候需要设置为true
 * @returns {AxiosPromise}
 */
export const getCurrentUserInfo = (corpNo = null, NotNeedErrorMessage = false) => {
  let url = `${base}${cu}/user/getCurrentUserInfo`
  if (corpNo) {
    url += '?corpNo=' + corpNo
  }
  return request({
    url: url,
    headers: {
      ...(NotNeedErrorMessage ? { NotNeedErrorMessage: true } : {})
    },
    method: 'get'
  })
}

/**
 * 获取企业用户数量
 */
export const corpUserNum = () => {
  return request({
    url: `${base}${cu}/user/getCorpUserNum`,
    method: 'get'
  })
}

/**
 * 获取企业用户列表
 */
export const corpUserList = () => {
  return request({
    url: `${base}${cu}/user/getCorpUserList`,
    method: 'get'
  })
}

/**
 * 添加企业用户数据
 */
export const addCorpUser = (params) => {
  return request({
    url: `${base}${cu}/user/add`,
    method: 'post',
    data: params
  })
}

/**
 * 修改企业用户数据
 */
export const editCorpUser = (params) => {
  return request({
    url: `${base}${cu}/user/edit`,
    method: 'post',
    data: params
  })
}

/**
 * 删除企业用户数据
 */
// export const removeCorpUser = id => {
//     return request({
//         url: `${base}${cu}/user/remove/${id}`,
//         method: 'delete'
//     })
// }

/**
 * 删除企业用户数据
 * @param userCode
 * @returns {AxiosPromise}
 */
export const removeCorpUser = (userCode) => {
  return request({
    url: `${spBase}/all${cu}/app/removeCorpUser/${userCode}`,
    method: 'delete'
  })
}

/**
 * 修改企业用户手机号-获取短信验证码
 */
// export const getSmsValiCode = (param) => {
//   return request({
//     url: `${base}${cu}/user/getSmsValiCode`,
//     method: 'get',
//     params: param
//   })
// }

export const getSmsValiCode = (param, data) => {
  return request({
    url: `${base}${cu}/user/getSmsCaptcha`,
    method: 'post',
    data: data,
    params: param
  })
}

/**
 * 修改企业用户手机号
 */
export const updatePhone = (phone, smsValiCode) => {
  return request({
    url: `${base}${cu}/user/updatePhone?phone=${phone}&smsValiCode=${smsValiCode}`,
    method: 'post'
  })
}

/**
 * 修改企业用户邮箱-获取邮件验证码
 */
 export const getEmailValiCode = (param) => {
  return request({
    url: `${base}${cu}/user/getEmailValiCode`,
    method: 'get',
    params: param
  })
}

/**
 * 修改企业用户邮箱
 */
export const updateEmail = (email, emailValiCode) => {
  return request({
    url: `${base}${cu}/user/updateEmail?email=${email}&emailValiCode=${emailValiCode}`,
    method: 'post'
  })
}

/**
 * 微信绑定
 */
 export const bindWechat = (oauth2Sessionid) => {
  return request({
    url: `${base}${cu}/user/bindWechat?oauth2Sessionid=${oauth2Sessionid}`,
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/corporation/user.js